import { isAfterNow, isBeforeNow } from '@betty/toolkit/utils';
import { SaleStatus, ShopSaleType } from '../state/sales/sales.types';
import { ShopFilterType } from '../state/types';
import { ShopItemPurchaseResponseType } from '../state/items/items.types';
import { shopItemRewardTypeMap } from '../content/shop.content';

export function getSaleStatus(sale: ShopSaleType) {
  const { availableFrom, availableTo } = sale;

  if (isAfterNow(availableFrom)) {
    return SaleStatus.Upcoming;
  }

  if (isBeforeNow(availableTo)) {
    return SaleStatus.Ended;
  }

  return SaleStatus.Ongoing;
}

export function parseFilter(filter: ShopFilterType | undefined) {
  // If the filter is a numeric string (sale filter), convert it to numbe type
  return !isNaN(Number(filter)) ? Number(filter) : filter;
}

export function parseShopItemRewards(response: ShopItemPurchaseResponseType) {
  return response.purchasedItems.map(
    ({ type, amount, freeSpinsGameId, status, coinsBackupValue }) => {
      let rewardType = type;
      let rewardAmount = amount;
      let gameIds = freeSpinsGameId ? [freeSpinsGameId] : undefined;

      // Replace failed Free Spins with Coins
      if (status === 'BackupAwarded' && coinsBackupValue) {
        rewardType = 'CoinsReward';
        rewardAmount = coinsBackupValue;
        gameIds = undefined;
      }

      return {
        rewardType: shopItemRewardTypeMap[rewardType],
        rewardAmount,
        gameIds,
      };
    },
  );
}
